/** @ngInject */
export class ReportModalBean {
    constructor(supportedReports, withDateRange, withLastAndUnread, params, group) {
        this.supportedReports = supportedReports;
        this.withDateRange = withDateRange;
        this.withLastAndUnread = withLastAndUnread;
        this.params = params;
        this.group = group;
    }
}
